import { z } from 'zod';
export const uuid = z.string().uuid();
export const isoDateTime = z.string().datetime({ offset: true });
export const pageQuery = z.object({
    page: z.coerce.number().int().min(1).default(1),
    perPage: z.coerce.number().int().min(1).max(200).default(50),
    q: z.string().trim().max(200).optional(),
});
export function paged(item) {
    return z.object({
        items: z.array(item),
        total: z.number().int(),
        page: z.number().int(),
        perPage: z.number().int(),
    });
}
export const apiError = z.object({
    code: z.string(),
    message: z.string(),
    details: z.unknown().optional(),
});
//# sourceMappingURL=common.js.map